// extracted by mini-css-extract-plugin
export default {"message-text":"messages-detail_component_message-text__WrDdN"};